import { Box, Container } from "@mui/material";
import React, { useEffect } from "react";
import { Markdown } from "src/components/markdown";
import { MainLayout } from "src/layouts/main";

const TermsOfUserView = () => {
  useEffect(() => {
    // window.location.href = "https://riple.org/terms.html";
  }, []);
  return (
    <MainLayout>
      <Container sx={{ py: 5 }}>
        <Markdown>{`# **Terms & Conditions**

The Riple website located at **riple.org** is a copyrighted work belonging to Riple. Certain features of the Site may be subject to additional guidelines, terms, or rules, which will be posted on the Site in connection with such features.

All such additional terms, guidelines, and rules are incorporated by reference into these Terms.

These Terms of Use describe the legally binding terms and conditions that govern your use of the Site. **BY LOGGING INTO THE SITE, YOU AGREE TO BE BOUND BY THESE TERMS** and you represent that you have the authority and capacity to enter into these Terms. **YOU MUST BE AT LEAST 18 YEARS OF AGE TO ACCESS THE SITE. IF YOU DISAGREE WITH ANY PROVISION OF THESE TERMS, DO NOT LOG INTO OR USE THE SITE.**

These Terms require the use of **arbitration (see Section 10.2)** on an individual basis to resolve disputes and limit the remedies available to you in the event of a dispute.

---

## **1. Accounts**

### 1.1 Account Creation

To use the Site, you must create an account and provide certain information about yourself. You represent and warrant that:

* (a) all registration information you submit is truthful, current, and accurate, and
* (b) you will maintain the accuracy of such information.

You may delete your account at any time by following the instructions provided on the Site. The Company may suspend or terminate your account in accordance with these Terms.

### 1.2 Account Responsibilities

You are responsible for maintaining the confidentiality of your account login information and for all activities that occur under your account. You agree to notify the Company immediately of any unauthorized use or suspected unauthorized use of your account. The Company is not liable for any loss or damage arising from your failure to comply with these responsibilities.

---

## **2. Access to the Site**

### 2.1 License

Subject to these Terms, the Company grants you a non-transferable, non-exclusive, revocable, limited license to access and use the Site solely for your personal, non-commercial use.

### 2.2 Restrictions

Your access rights are subject to the following restrictions:

* (a) You shall not sell, rent, lease, transfer, assign, distribute, host, or otherwise commercially exploit the Site.
* (b) You shall not modify, create derivative works of, disassemble, reverse compile, or reverse engineer any part of the Site.
* (c) You shall not access the Site to build a similar or competitive website.
* (d) Except as expressly stated herein, no part of the Site may be copied, reproduced, distributed, republished, downloaded, displayed, posted, or transmitted in any form or by any means.

Unless otherwise indicated, any future release, update, or other addition to the functionality of the Site will be subject to these Terms. All copyright and other proprietary notices must be retained on all copies.

### 2.3 No Support or Maintenance

You agree that the Company has no obligation to provide support or maintenance related to the Site.

### 2.4 Modifications

The Company reserves the right to modify, suspend, or discontinue the Site at any time without notice. You agree that the Company shall not be liable to you or any third party for any modification, suspension, or discontinuation of the Site or any part thereof.

Except for any User Content you may provide, you acknowledge that all intellectual property rights in the Site and its content are owned by the Company or its suppliers. These Terms do not grant you any rights, title, or interest in any intellectual property, except for the limited access rights in Section 2.1.

---

## **3. User Content**

### 3.1 Definition

“User Content” means any information or content that you submit to the Site.

### 3.2 Responsibility

You are solely responsible for your User Content and bear all risks associated with its use. You certify that your User Content does not violate the Acceptable Use Policy (see Section 3.4). You may not represent or imply that your User Content is in any way provided, sponsored, or endorsed by the Company.

The Company is not obligated to back up any User Content you post and it may be deleted at any time without prior notice. You are solely responsible for maintaining backup copies if desired.

### 3.3 License

You grant the Company an irrevocable, non-exclusive, royalty-free, fully paid, worldwide license to:

* Reproduce
* Distribute
* Publicly display and perform
* Prepare derivative works of
* Incorporate into other works
* Use and exploit your User Content

You also grant the Company the right to sublicense these rights for the sole purpose of including your User Content in the Site.

You irrevocably waive any moral rights or claims to attribution regarding your User Content.

### 3.4 Acceptable Use Policy

You agree **not to use the Site** to upload, transmit, distribute, display, or otherwise make available any User Content that:

* Violates the intellectual property rights or proprietary rights of any third party.
* Is unlawful, harmful, fraudulent, deceptive, threatening, harassing, defamatory, obscene, or otherwise objectionable.
* Contains viruses, malware, or other harmful content.
* Attempts to gain unauthorized access to systems, networks, or data.
* Interferes with or disrupts the integrity or performance of the Site.`}</Markdown>
      </Container>
    </MainLayout>
  );
};

export default TermsOfUserView;
